import React from "react";
import PropTypes from "prop-types";
import {
    // Drawer,
    Input,
    Button,
    Row,
    Col,
    Timeline,
    Card,
    Tag
} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchCaseNotes, createCaseNote } from "store/actions";
import { STATE_STATUS } from "constants/index";
import { CaseNoteRecord } from "records/case-note-record";
import shortID from "uuid/v4";
import moment from "moment";

class MISReport extends React.Component {
    state = {
        note: null
    };
    componentDidMount() {
        this.handleNotesFetch();
    }

    componentDidUpdate() {
        this.handleNotesFetch();
    }

    handleNotesFetch() {
        if (
            // this.props.location.state &&
            // this.props.location.state.case_notes &&
            // this.props.location.state.case_notes.case_notes_view &&
            !this.props.notesStatus ||
            this.props.notesStatus === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchCaseNotes(this.props.caseId);
        }
    }

    createCaseNote = () => {
        this.props.createCaseNote(
            this.props.caseId,
            shortID(),
            new CaseNoteRecord({
                user: this.props.user,
                case: this.props.caseId,
                stage: this.props.stage,
                notes: this.state.note,
                create_date: moment(),
                state_status: STATE_STATUS.CREATING
            })
        );
    };
    hideCaseNote = () => {
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_notes: {
                case_notes_view: false
            }
        });
    };
    onEdit = event =>
        this.setState({
            note: event.target.value
        });
    render() {
        return (
            <Row>
                <Col span={24}>
                    <Row
                        className={"d-flex flex-column"}
                        style={{ height: "100vh", background: "white" }}
                    >
                        <Col span={24} className={"p-5"}>
                            <h3>Case Notes</h3>
                        </Col>
                        <Col
                            span={24}
                            style={{
                                flexGrow: 1,
                                maxHeight: "70vh",
                                overflowY: "scroll"
                            }}
                            className={"p-5"}
                        >
                            <Timeline>
                                {this.props.notes &&
                                    this.props.notes
                                        .toList()
                                        .sort((a, b) =>
                                            a.create_date.isBefore(
                                                b.create_date
                                            )
                                                ? -1
                                                : 1
                                        )
                                        .map(_ => (
                                            <Timeline.Item key={_.id}>
                                                <Card
                                                    className={"mb-10 align-items-center"}
                                                    size={"small"}
                                                    type={"inner"}
                                                >
                                                    {_.notes}
                                                </Card>
                                                <div>
                                                    <Tag>
                                                        {_.create_date.format(
                                                            "DD-MM-YYYY"
                                                        )}
                                                    </Tag>
                                                    <Tag>
                                                        {_.stage &&
                                                            _.stage.stage_name}
                                                    </Tag>
                                                    <Tag>
                                                        {_.user &&
                                                            _.user.full_name}
                                                    </Tag>
                                                </div>
                                            </Timeline.Item>
                                        ))}
                            </Timeline>
                        </Col>
                        <Col span={24} className={"mb-5 px-5 mt-10"}>
                            <Input.TextArea
                                rows={4}
                                style={{ width: "100%" }}
                                placeholder={"Add case note..."}
                                value={this.state.note}
                                onChange={this.onEdit}
                            />
                        </Col>
                        <Col
                            span={24}
                            className={"px-5 d-flex justify-content-flex-end"}
                        >
                            <Button
                                type={"primary"}
                                block={true}
                                onClick={this.createCaseNote}
                                disabled={this.props.recreditViewOnlyPermission}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

MISReport.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    user: PropTypes.number,
    stage: PropTypes.number,
    notesStatus: PropTypes.string,
    notes: PropTypes.object,
    fetchCaseNotes: PropTypes.func,
    createCaseNote: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const caseId = props.caseId;
    return {
        // caseId,
        stage:
            props.stageId &&
            state.stages.get("data").find(_ => _.id === props.stageId),
        user: state.user.get("data"),
        notesStatus: state.caseNotes.getIn([caseId, "status"]),
        notes: state.caseNotes.getIn([caseId, "notes"])
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCaseNotes,
            createCaseNote
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MISReport);
